import { sendApiRequest } from "../lib/helper";
import { IAccreditor, IAccreditorRule, IAccreditorRuleFieldDefinition, ICriteria } from "../types/IAccreditor";
import { getItems, updateItem } from "./sql";

export const getAccreditors = (): Promise<IAccreditor[]> => {
    return getItems("getListOfAccreditors");
};

export const getAccreditorFieldDefinitions = (): Promise<IAccreditorRuleFieldDefinition[]> => {
    return getItems("getListOfAccreditorFieldDefinitions");
};

export const getListOfCriteriaDefinitions = (): Promise<ICriteria[]> => {
    return getItems("getListOfCriteriaDefinitions");
}

export const getAccreditorRules = (accreditor: IAccreditor): Promise<IAccreditorRule[]> => {
    return sendApiRequest(`/api/sql/getListOfAccreditorRules?accreditorId=${accreditor.AccreditorId}`, "GET");
};

export const updateAccreditorRules = (course: string, accreditor: number, accreditorRules: IAccreditorRule[]): Promise<any> => {
    return updateItem("updateAccreditorRules", {
        accreditorRules: JSON.stringify(accreditorRules),
        course: course,
        accreditor: accreditor
    });
};

export const getAccreditationRuleDefinitionLabel = (accreditorFieldDefinition: IAccreditorRuleFieldDefinition) => `${accreditorFieldDefinition.Category}${accreditorFieldDefinition.Competency ? " - " + accreditorFieldDefinition.Competency : ""}`;